import { FormHelperText } from '@mui/material';
import styled from 'styled-components';
import { colors, fonts } from '../utils';

const { colorTextDark, darkBackground3Light, green1, red } = colors;
const { primaryFont } = fonts;

export const Flex = styled.div`
	display: flex;
	justify-content: ${(props) => (props.jc ? props.jc : 'flex-start')};
	align-items: ${(props) => (props.ai ? props.ai : 'center')};
	gap: ${(props) => props.gap && props.gap};
	flex-wrap: ${(props) => props.fw && props.fw};
	flex-flow: ${(props) => props.ff && props.ff};
	height: ${(props) => props.height && props.height};
	margin: ${(props) => props.margin && props.margin};
	margin-bottom: ${(props) => props.mb && props.mb};
	margin-top: ${(props) => props.mt && props.mt};
	padding: ${(props) => props.padding && props.padding};
	width: ${(props) => props.width && props.width};
	overflow-x: ${(props) => props.overflowX && props.overflowX};

	& a {
		width: ${(props) => props.width && props.width};
	}

	@media only screen and (max-width: 768px) {
		justify-content: ${(props) => props.jc768 && props.jc768};
		align-items: ${(props) => props.ai768 && props.ai768};
		flex-flow: ${(props) => props.ff768 && props.ff768};
	}
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: ${(props) => (props.gtc ? props.gtc : 'repeat(2, 1fr)')};
	grid-gap: ${(props) => (props.gg ? props.gg : '2.5rem')};
	margin: ${(props) => props.margin && props.margin};
	align-items: ${(props) => props.ai && props.ai};
		padding: ${(props) => props.padding && props.padding}; /* Add padding here */


	@media only screen and (max-width: 768px) {
		grid-template-columns: ${(props) => props.gtc768 && props.gtc768};

	}
`;

export const MHeading = styled.h3`
	font-size: ${(props) => (props.fs ? props.fs : '1.2rem')};
	margin-bottom: ${(props) => props.mb && props.mb};
	margin-top: ${(props) => props.mt && props.mt};
	margin-left: ${(props) => props.ml && props.ml};
	color: ${(props) => props.color && props.color};
	align-self: ${(props) => props.as && props.as};
	text-align: ${(props) => props.align && props.align};
	font-weight: ${(props) => props.fw && props.fw};

	@media only screen and (max-width: 768px) {
		margin-bottom: ${(props) => props.mb768 && props.mb768};
	}
`;

export const Text = styled.p`
	font-size: ${(props) => (props.fs ? props.fs : '1.2rem')};
	font-weight: ${(props) => props.fw && props.fw};
	color: ${(props) => props.color && props.color};
`;

export const TableHeading = styled.h4`
	font-size: 1.3rem;
	color: ${colorTextDark};
	text-decoration: underline;
	text-transform: capitalize;
	cursor: ${(props) => props.cursor && props.cursor};
`;

export const PositionHandler = styled.div`
	position: ${(props) => (props.position ? props.position : 'relative')};
	top: ${(props) => props.top && props.top};
	left: ${(props) => props.left && props.left};
	bottom: ${(props) => props.bottom && props.bottom};
	right: ${(props) => props.right && props.right};
	z-index: ${(props) => props.zIndex && props.zIndex};
	margin-top: ${(props) => props.mt && props.mt};
`;

export const HLine = styled.div`
	width: ${(props) => (props.width ? props.width : '100%')};
	height: ${(props) => (props.height ? props.height : '0.02rem')};
	margin: ${(props) => props.margin && props.margin};
	background-color: ${(props) => (props.bgColor ? props.bgColor : darkBackground3Light)};
`;

export const Label = styled.label`
	font-size: ${(props) => (props.fs ? props.fs : '1.4rem')};
	margin-bottom: ${(props) => (props.mb ? props.mb : '0.5rem')};
`;

export const MarginHandler = styled.div`
	margin: ${(props) => props.margin && props.margin};
	margin-top: ${(props) => props.mt && props.mt};
	margin-bottom: ${(props) => props.mb && props.mb};
	margin-left: ${(props) => props.ml && props.ml};
	width: ${(props) => props.width && props.width};

	& label {
		font-size: 1.4rem !important;
		font-weight: 500 !important;
		font-family: ${primaryFont};
	}

	& input {
		font-size: 1.2rem !important;
		font-weight: 600 !important;
		font-family: ${primaryFont};
	}
`;

export const WidthHandler = styled.div`
	width: ${(props) => (props.width ? props.width : '100%')};
	min-width: ${(props) => props.minWidth && props.minWidth};
	max-width: ${(props) => props.maxWidth && props.maxWidth};
`;

export const AttendanceIconBg = styled.div`
	width: 1.8rem;
	height: 1.8rem;
	border-radius: 50%;
	background-color: ${(props) => (props.bg ? props.bg : green1)};
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ErrorMsg = styled.div`
	color: ${(props) => (props.clr ? props.color : '#FF0039')};
`;

export const InputError = styled(FormHelperText)`
	color: ${red};
	font-size: 1.4rem;
	font-family: ${primaryFont};
	font-weight: 600;
`;
